<template lang="pug">
.v-main-section-header.main-section-header
	h3.main-section-header__title(
			v-if="data.title"
			:class="{'short': data.description || data.achievements }")
		| {{ data.title }}
	.main-section-header__description(v-if="data.description" ) {{ data.description }}
	.main-section-header__buttons(v-if="data.navigation" )
		button.main-section-header__button.slider-btn.left(ref="prev")
		button.main-section-header__button.slider-btn.right(ref="next")
	.main-section-header__achievements(v-else-if="data.achievements && data.achievements.length")
		.main-section-header__achievement.achievement(v-for="(achievement, index) in data.achievements" :key="index")
			.achievement__title(v-if="achievement.title" ) {{ achievement.title }}
			.achievement__number.numbers(v-if="achievement.number" ) {{ achievement.number }}
			h4.achievement__postfix(v-if="achievement.postfix" ) {{ achievement.postfix }}

</template>

<script>
import observer from "../scripts/helpers/observer.js";
export default {
	emits: ['navigation'],

	props: {
		data: {
			type: Object,
			default: null
		},
	},

	data() {
		return {
			navigation: false
		}
	},

	methods: {
		setNavigation() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		}
	},

	mounted() {
		this.setNavigation()
		this.$emit('navigation', this.navigation);

		const headers = document.querySelectorAll('.main-section-header');
		headers.forEach(header => observer({threshold: 0.5}).observe(header))
	}
};
</script>